module.exports = __webpack_public_path__ + "img/4.9d50ab80.jpg";